import SoftwareLicenseList from "@/components/lists/software-license-list.vue"
export default {
    components : {
        SoftwareLicenseList
    }
}
